import {
  getSensor,
  getTelescopePackage,
} from '../data/hardwareCatalog';

function formatUsd(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
}

export default function CostProjectionHardwareSummary({
  hardwareConfig,
  hardwareCostResult,
}) {
  const telescope = getTelescopePackage(hardwareConfig.telescopePackageId);
  const sensor = getSensor(hardwareConfig.sensorId);

  return (
    <div className="pt-2 border-t border-glass-border">
      <div className="text-xs text-amber-200/60 mb-2 tracking-wider">
        HARDWARE CONFIGURATION
      </div>
      <dl className="space-y-1.5 text-sm font-mono text-amber-100">
        <div className="flex justify-between gap-4">
          <dt className="text-amber-300/60 shrink-0">Telescope</dt>
          <dd className="text-right">{telescope.label}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="text-amber-300/60 shrink-0">Sensor</dt>
          <dd className="text-right">{sensor.label}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="text-amber-300/60 shrink-0">Telescopes / module</dt>
          <dd className="text-right">{hardwareCostResult.telescopesPerModule}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="text-amber-300/60 shrink-0">Hardware BOM / module</dt>
          <dd className="text-right">
            {formatUsd(hardwareCostResult.hardwareCostPerModule)}
          </dd>
        </div>
      </dl>
      <p className="text-xs text-amber-300/50 mt-2">
        Edit via HARDWARE COSTING
      </p>
    </div>
  );
}
